import { SoundMap } from '../constants/sounds';
import type { SoundId } from '../types/sounds';
import { type SoundInstance } from '../types/sounds';
import { fetchSound } from '../utils/sound';

const findSoundByResourceSrc = (resourceSrc: string) => {
  const keys = Object.keys(cache) as Array<SoundId>;
  const sounds = keys.reduce<Array<SoundInstance>>((acc, key) => {
    const sound = cache[key];

    if (sound) {
      return [...acc, sound];
    }

    return acc;
  }, []);

  for (const sound of sounds) {
    const { src } = sound;

    if (src === resourceSrc) {
      return sound;
    }
  }
};

const cache: Partial<Record<SoundId, SoundInstance>> = {};

class SoundPlayer {
  static load = async (soundId: SoundId): Promise<SoundInstance> =>
    new Promise((resolve, reject) => {
      const resource = SoundMap[soundId];

      if (!resource) {
        console.warn('SoundPlayer - sound not found', soundId);
        reject();
      } else {
        const { src: resourceSrc } = resource;
        const cachedSound = cache[soundId] ?? findSoundByResourceSrc(resourceSrc);

        if (cachedSound) {
          const state = cachedSound.getState();

          if (state === 'loaded') {
            resolve(cachedSound);
          } else if (state === 'loading') {
            cachedSound.on('load', () => {
              resolve(cachedSound);
            });
          } else {
            console.warn('SoundPlayer - sound cannot be loaded', soundId);
            reject();
          }
        } else {
          fetchSound(resource, soundId).then((sound) => {
            cache[soundId] = sound;
            resolve(sound);
          });
        }
      }
    });
}

export default SoundPlayer;
